import Container from "react-bootstrap/Container";
import ListGroup from "react-bootstrap/ListGroup";
import { MdArrowForwardIos } from "react-icons/md";
import { Link } from "react-router-dom";
import CustomNavBar from "./CustomNavBar";

function About() {
  return (
    <>
      <CustomNavBar title={"About Zooppay"} />
      <section className="profile-summary-wrapper">
        <div className="desktop-wrapper">
          <Container className="cart-wrapper">
            <h4>Contact Us</h4>
            <ListGroup>
              <ListGroup.Item>
                <p>For Support/Enquiries</p>
                <h6>+91 826-010-6669</h6>
              </ListGroup.Item>
              <ListGroup.Item>
                <p>Email</p>
                <h6>info@zooppay.com</h6>
              </ListGroup.Item>
              <ListGroup.Item>
                <p>Address</p>

                <h6>DCB 609, 6TH FLOOR, DLF CYBER CITY</h6>
                <h6>PATIA Khordha 751024</h6>
                <h6>Bhubaneswar, Odisha</h6>
              </ListGroup.Item>
            </ListGroup>
            <ListGroup className="mt-5">
              <Link to="/howitworks">
                <ListGroup.Item>
                  <h6>How its works?</h6>
                  <MdArrowForwardIos />
                </ListGroup.Item>
              </Link>
            </ListGroup>
            <ListGroup>
              <Link to="/privacy">
                <ListGroup.Item>
                  <h6>Privacy Policy</h6>
                  <MdArrowForwardIos />
                </ListGroup.Item>
              </Link>
            </ListGroup>

            <ListGroup>
              <Link to="/refund">
                <ListGroup.Item>
                  <h6>Return Policy</h6>
                  <MdArrowForwardIos />
                </ListGroup.Item>
              </Link>
            </ListGroup>
            <p className="small mt-5 muted copywrites">
              Copyright © 2023 Zooppay. Ltd. All rights reserved.
            </p>
          </Container>
        </div>
      </section>
    </>
  );
}

export default About;
